import script from "./Toasts.vue?vue&type=script&lang=js"
export * from "./Toasts.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__